import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import React from "react";

export interface IOrganizationSimpleModel extends IGenericBaseModel{
    uuid?: string;
    dateCreated?: string;
    dateModified?: string;
    isActive?: boolean;
    name: string;
    fullName?: string;
}

export class OrganizationSimpleModel implements IOrganizationSimpleModel  {
    uuid?: string;
    key?: React.Key;
    dateCreated?: string;
    dateModified?: string;
    isActive?: boolean;
    name: string;
    fullName?: string;

    constructor(data: IOrganizationSimpleModel) {
        this.uuid = data.uuid;
        this.key = data.uuid;
        this.dateCreated = data.dateCreated;
        this.dateModified = data.dateModified;
        this.isActive = data.isActive ?? true;
        this.name = data.name;
        this.fullName = data.fullName;
    }
}




